import { clinicTypes } from '../consts'
import {
  filterHTNFollowUpAppointments,
  filterMHFollowUpAppointments,
  filterDMFollowUpAppointments,
  filterPrimaryAppointmentsPerMember,
} from './appointmentsUtils'
import { filterCanEditPersonalData } from './familyPermissionsUtils'

export const isNeedAppointmentForSomeOneElse = state => {
  return (
    state?.appointment?.participants?.length > 1 ||
    (state?.appointment?.participants[0]?.id &&
      state?.profile?.userDetails?.id !==
        state?.appointment?.participants[0]?.id)
  )
}

export const isNeedToAskEmergencyContactUpdate = state => {
  const userDetails = state?.profile?.userDetails
  const selectedMember = state?.account?.selectedMember

  return !(selectedMember?.id
    ? selectedMember?.emergencyContact?.phoneNumber ||
      !filterCanEditPersonalData(selectedMember)
    : userDetails?.emergencyContact?.phoneNumber)
}

export const isNeedToAskSex = state => {
  if (state.profile.userDetails?.sex || state.account?.selectedMember?.sex)
    return false
  return true
}

export const isReferredFirstTime = (state, pendingAppointment) => {
  if (!state.profile.userDetails || !state.profile.userDetails.referrer) {
    return false
  }
  if (
    !pendingAppointment.metadata ||
    !pendingAppointment.metadata['referrer_org']
  ) {
    return false
  }
  return true
}

export const filterFollowUpAppointments = state => {
  if (state.getCare.isHTNFollowUp) {
    return filterHTNFollowUpAppointments(state?.appointments?.appointments)?.[0]
  }
  if (state.getCare.isMHFollowUp) {
    return filterMHFollowUpAppointments(state?.appointments?.appointments)?.[0]
  }
  if (state.getCare.isDMFollowUp) {
    return filterDMFollowUpAppointments(state?.appointments?.appointments)?.[0]
  } else {
    return null
  }
}

export const isNeedToShowQueueAppointmentsPage = state => {
  const selectedService = state.getCare?.selectedService
  const isPrimaryServiceSelected = selectedService === clinicTypes.PRIMARY
  const selectedMember =
    state.account?.selectedMember || state.profile?.userDetails
  const isQueueAppointmentExistPerMember =
    filterPrimaryAppointmentsPerMember(
      state.appointments?.appointments,
      selectedMember?.id
    )?.length > 0

  return isQueueAppointmentExistPerMember && isPrimaryServiceSelected
}

export const isNeedToAskIntent = state => {
  return state?.getCare?.hmoSelectedIntent?.length === 0
}
